export enum TruckMaterialType {
  TRUCK_TYPE = "truck",
  MATERIAL_TYPE = "material",
}

export enum TruckMaterialJobType {
  TRUCKING_JOB = "Trucking Job",
  TRUCKING_AND_MATERIAL_JOB = "Trucking & Material Job",
}

export enum CheckboxType {
  PICKUP = "pickup",
  DELIVERY = "delivery",
}
